import { render, staticRenderFns } from "./loanListDetails.vue?vue&type=template&id=2e413d98&scoped=true&"
import script from "./loanListDetails.vue?vue&type=script&lang=js&"
export * from "./loanListDetails.vue?vue&type=script&lang=js&"
import style0 from "./loanListDetails.vue?vue&type=style&index=0&id=2e413d98&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e413d98",
  null
  
)

export default component.exports